export function getCustomAttribute(item, code) {
  const attr = item.custom_attributes?.find(a => a.attribute_code === code);
  return attr ? attr.value : null;
}

export function getLabelFromCustomAttributeValue(options, value) {
  return options.find(o => String(o.value) === String(value))?.label || value;
}

export const extractColors = (item, allItems, colorOptions = []) => {
  const type = getCustomAttribute(item, 'profitmaker_sku')?.toLowerCase();
  if (type === 'hat' || type === 'apparel') return [];

  const getLabel = (val) =>
    colorOptions.find(o => String(o.value) === String(val))?.label || val;

  if (
    item.type_id === 'configurable' &&
    item.extension_attributes?.configurable_product_links?.length
  ) {
    const childIds = item.extension_attributes.configurable_product_links.map(String);
    const children = allItems.filter(p => childIds.includes(String(p.id)));

    const colorSet = new Map();

    for (const child of children) {
      const value = getCustomAttribute(child, 'fashion_color');
      if (value && !colorSet.has(value)) {
        const label = getLabel(value);
        colorSet.set(value, { value, label });
      }
    }

    return [...colorSet.values()];
  }

  const value = getCustomAttribute(item, 'fashion_color');
  const label = getLabel(value);
  return value ? [{ value, label }] : [];
};

export const extractSizes = (item, allItems, sizeOptions = []) => {
  const type = getCustomAttribute(item, 'profitmaker_sku')?.toLowerCase();
  if (type === 'hat') return [];

  const getLabel = (val) =>
    sizeOptions.find(o => String(o.value) === String(val))?.label || val;

  if (
    item.type_id === 'configurable' &&
    item.extension_attributes?.configurable_product_links?.length
  ) {
    const childIds = item.extension_attributes.configurable_product_links.map(String);
    const children = allItems.filter(p => childIds.includes(String(p.id)));

    const sizeSet = new Map();

    for (const child of children) {
      const value = getCustomAttribute(child, 'fashion_size');
      if (value && !sizeSet.has(value)) {
        const label = getLabel(value);
        sizeSet.set(value, { value, label });
      }
    }

    return [...sizeSet.values()];
  }

  const value = getCustomAttribute(item, 'fashion_size');
  const label = getLabel(value);
  return value ? [{ value, label }] : [];
};

export function getCustomAttributeValue(product, code) {
  return product.custom_attributes?.find(attr => attr.attribute_code === code)?.value;
}

export function findMatchingChildSku(parentProduct, selectedSize, selectedColor) {
  const children = parentProduct.children || [];

  for (const child of children) {
    const attrs = child.custom_attributes || [];
    const sizeAttr = attrs.find(a => a.attribute_code === 'fashion_size');
    const colorAttr = attrs.find(a => a.attribute_code === 'select_color');

    const sizeMatch = !selectedSize || sizeAttr?.value === String(selectedSize);
    const colorMatch = !selectedColor || colorAttr?.value === String(selectedColor);

    if (sizeMatch && colorMatch) {
      return child.sku;
    }
  }

  return parentProduct.sku;
}
